// 가격 포맷팅 함수
export const formatPrice = (price) => {
  if (!price) return '가격 정보 없음';
  return `₩${price.toLocaleString()}`;
};

// 날짜 포맷팅 함수
export const formatDate = (dateString, includeSeconds = false) => {
  if (!dateString) return '-';
  
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  };
  
  if (includeSeconds) {
    options.second = '2-digit';
  }
  
  return new Date(dateString).toLocaleString('ko-KR', options);
};

// 상태 설정 가져오기 함수
export const getStatusConfig = (status) => {
  const statusConfig = {
    'ACTIVE': { text: '판매가능', className: 'bg-green-100 text-green-800' },
    'PRE_ORDER': { text: '사전주문', className: 'bg-yellow-100 text-yellow-800' },
    'SOLD_OUT': { text: '품절', className: 'bg-red-100 text-red-800' }
  };
  return statusConfig[status] || { text: '알 수 없음', className: 'bg-gray-100 text-gray-800' };
};

// 사이트명과 색상 정보 가져오기 함수
export const getSiteConfig = (site) => {
  const siteConfigs = {
    'oliveyoung': { name: '올리브영', style: { color: '#9BCE26' } },
    'musinsa': { name: '무신사', style: { color: '#111113' } },
    'weverse': { name: '위버스', style: { color: '#02CBD5' } },
    'daiso': { name: '다이소', style: { color: '#D70211' } },
    'museum': { name: '국립박물관', style: { color: '#874D3C' } },
    'ktown': { name: '케이타운', style: { color: '#1E3A8A' } }
  };
  return siteConfigs[site] || { name: site, className: 'text-gray-600 font-semibold', style: {} };
};

// 사이트명 변환 함수 (기존 호환성 유지)
export const getSiteName = (site) => {
  const siteNames = {
    'oliveyoung': '올리브영',
    'musinsa': '무신사',
    'weverse': '위버스',
    'daiso': '다이소',
    'ktown': '케이타운'
  };
  return siteNames[site] || site;
};

// 텍스트 자르기 함수
export const truncateText = (text, maxLength) => {
  if (!text) return '-';
  return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
};
